import { render, staticRenderFns } from "./TargetContentPlacements.vue?vue&type=template&id=ce9d82a8&scoped=true&"
import script from "./TargetContentPlacements.vue?vue&type=script&lang=js&"
export * from "./TargetContentPlacements.vue?vue&type=script&lang=js&"
import style0 from "./TargetContentPlacements.vue?vue&type=style&index=0&id=ce9d82a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9d82a8",
  null
  
)

export default component.exports